import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientMainPanelComponent } from './components/client-main-panel/client-main-panel.component';
import { ClientLeftPanelComponent } from './components/client-left-panel/client-left-panel.component';
import { ClientHeaderPanelComponent } from './components/client-header-panel/client-header-panel.component';
import { ClientEntitiesComponent } from './components/client-entities/client-entities.component';
import { ClientSessionComponent } from './components/client-session/client-session.component';
import { DesktopClientRoutingModule } from './desktop-client-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { BrowserModule } from '@angular/platform-browser';
import { ClientApplicationsComponent } from './components/client-applications/client-applications.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SafeHtmlPipe } from '../../core/pipes/safe-html.pipe';
import { AppRoutingModule } from '../../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgChartsModule } from 'ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMarqueeModule } from 'ng-marquee';
import { WebClientSessionComponent } from './components/web-client-session/web-client-session.component';


@NgModule({
  declarations: [
    ClientMainPanelComponent,
    ClientLeftPanelComponent,
    ClientHeaderPanelComponent,
    ClientEntitiesComponent,
    ClientSessionComponent,
    ClientApplicationsComponent,
    WebClientSessionComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AngularMaterialModule,
    CoreModule,
    DesktopClientRoutingModule,
    NgxSpinnerModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    NgChartsModule,
    NgbModule,
  ],
  providers: [SafeHtmlPipe]
})
export class DesktopClientModule { }
